// extracted by mini-css-extract-plugin
export var centerList = "_gv-6";
export var centerLoc = "_gv-a";
export var centerName = "_gv-9";
export var centerOptionBody = "_gv-8";
export var centerRow = "_gv-7";
export var centerStatus = "_gv-b";
export var empty = "_gv-5";
export var externalIcon = "_gv-c";
export var fieldHeader = "_gv-2";
export var fieldHelp = "_gv-4";
export var fieldLabel = "_gv-3";
export var panel = "_gv-0";
export var removeBtn = "_gv-d";
export var section = "_gv-1";